import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('geo', ['serviceType', 'serviceTypeGroup']),
    ...mapState('heatmap', ['mapBounds', 'selectedGeo'])
  },

  methods: {
    ...mapActions('heatmap', ['setSelectedGeo']),

    handleRefreshClick () {
      this.setSelectedGeo({
        type: 'GeoBounds',
        id: this.mapBounds,
        slug: this.mapBounds,
        geo_bounds: this.mapBounds,
        name: 'Custom Area',
        is_available: true
      })

      this.$router.push({
        name: 'geo-show',
        params: {
          geoId: this.selectedGeo.slug,
          stg: this.serviceTypeGroup ? this.serviceTypeGroup.slug : null,
          st: this.serviceType ? this.serviceType.slug : null
        }
      })
      this.showRefresh = false
    }
  }
}



// WEBPACK FOOTER //
// ./frontend/src/mixins/geo-refresh-btn.js